<script>
import ResourceDetail from '@shell/components/ResourceDetail';

export default {
  name:       'RolesResourceCreate',
  components: { ResourceDetail },
};
</script>

<template>
  <ResourceDetail />
</template>
